module.exports = __webpack_public_path__ + "static/media/xiaomi.7e80788b.png";